import { AxiosError } from "axios";
import GroupForm from "../../components/group/form/GroupForm";
import GroupRedact from "../../components/group/redact/GroupRedact";
import GroupService from "../../services/GroupService";
import PhoneForm from "../../components/phone/form/PhoneForm";
import PhoneService from "../../services/PhoneService";
import Question from "../../UI/components/popups/question/Question";
import React from "react";
import { displayErrors } from "../../store/actions/error";
import store from "../../store/store";

interface Props {
  group: App.Group;
  index: number;
  onStartMove: (index: number) => void;
  onMouseEnter: (index: number) => void;
  onEndMove: () => void;
  updateCurrentGroup: (autocenter: App.Group) => void;
  onDelete: (id: number) => void;
}
interface State {
  isOpenForm: boolean;
  isOpenFormPhone: boolean;
  isOpenQuestion: boolean;
}

class GroupRedactContainer extends React.Component<Props, State> {
  private groupService: GroupService;
  private phoneService: PhoneService;
  constructor(props: Props) {
    super(props);
    this.groupService = new GroupService();
    this.phoneService = new PhoneService();
    this.state = {
      isOpenForm: false,
      isOpenFormPhone: false,
      isOpenQuestion: false,
    };
  }

  private handleRedact() {
    this.setState({ isOpenForm: true });
  }
  private handleTryDelete() {
    this.setState({ isOpenQuestion: true });
  }
  private handleTryAddPhone() {
    this.setState({ isOpenFormPhone: true });
  }

  private handleUpdate(group: App.GroupData) {
    group.weight = this.props.index;
    this.groupService
      .update(group, this.props.group.id)
      .then((response) => {
        this.setState({ isOpenForm: false });
        this.props.updateCurrentGroup(response.data);
      })
      .catch((error: AxiosError<Array<string>>) => {
        store.dispatch(
          displayErrors(
            error.response?.data || ["Не удалось редактировать группу"]
          )
        );
      });
  }
  private async handleDelete() {
    this.groupService
      .delete(this.props.group.id)
      .then(() => {
        this.setState({ isOpenQuestion: false });
        this.props.onDelete(this.props.group.id);
      })
      .catch((error: AxiosError<Array<string>>) => {
        store.dispatch(
          displayErrors(error.response?.data || ["Не удалось удалить группу"])
        );
      });
  }

  private async handleCreatePhone(phone: App.PhoneData) {
    phone.weight = this.props.group.phones.length;
    this.phoneService
      .create(phone, this.props.group.id)
      .then(() => {
        this.setState({ isOpenFormPhone: false });
      })
      .catch((error: AxiosError<Array<string>>) => {
        store.dispatch(
          displayErrors(
            error.response?.data || ["Не удалось редактировать номер"]
          )
        );
      });
  }
  private handleClose() {
    this.setState({
      isOpenFormPhone: false,
      isOpenForm: false,
      isOpenQuestion: false,
    });
  }

  public render() {
    return (
      <>
        <GroupRedact
          index={this.props.index}
          group={this.props.group}
          updateCurrentGroup={this.props.updateCurrentGroup}
          onStartMove={this.props.onStartMove}
          onMouseEnter={this.props.onMouseEnter}
          onEndMove={this.props.onEndMove}
          onTryRedact={this.handleRedact.bind(this)}
          onTryDelete={this.handleTryDelete.bind(this)}
          onTryAddPhone={this.handleTryAddPhone.bind(this)}
        />
        {this.state.isOpenForm && (
          <GroupForm
            group={this.props.group}
            submit={this.handleUpdate.bind(this)}
            close={this.handleClose.bind(this)}
          />
        )}
        {this.state.isOpenFormPhone && (
          <PhoneForm
            phone={null}
            submit={this.handleCreatePhone.bind(this)}
            close={this.handleClose.bind(this)}
          />
        )}
        {this.state.isOpenQuestion && (
          <Question
            question="Вы действительно хотите удалить группу?"
            onDisagree={this.handleClose.bind(this)}
            onAgree={this.handleDelete.bind(this)}
          />
        )}
      </>
    );
  }
}

export default GroupRedactContainer;
